export const AGGREGATION_WIDGET_TYPE = "aggregation";
const groupByForWidget = (config) => {
  if (!config) {
    return [];
  }
  const rowPivots = config.rowPivots.map((pivot) => ({ type: "row", fields: pivot.fields }));
  const columnPivots = config.columnPivots.map((pivot) => ({ type: "column", fields: pivot.fields }));
  return [...rowPivots, ...columnPivots];
};
const metricsForWidget = (config) => {
  if (!config) {
    return [];
  }
  return config.series.map((series) => ({ function: series.function, name: series.effectiveName }));
};
const chartResult = (widgetResult) => {
  var _a;
  return (_a = widgetResult == null ? void 0 : widgetResult.chart) != null ? _a : Object.values(widgetResult != null ? widgetResult : {})[0];
};
const createWidgetSummaryRequest = (view, widget, widgetResult) => {
  var _a, _b;
  const widgetTitle = view.getWidgetTitleByWidget(widget);
  const chart = chartResult(widgetResult);
  const headers = (_a = chart == null ? void 0 : chart.column_names) != null ? _a : [];
  const rows = ((_b = chart == null ? void 0 : chart.rows) != null ? _b : []).filter((r) => r.source === "leaf").flatMap((r) => r.values.map((subRow) => [[...r.key, ...subRow.key].join("."), subRow.value]));
  return {
    type: "widget",
    payload: {
      name: widgetTitle,
      description: widget.description,
      context: widget.context,
      config: {
        type: AGGREGATION_WIDGET_TYPE,
        group_by: groupByForWidget(widget.config),
        metrics: metricsForWidget(widget.config)
      },
      data: {
        headers,
        rows
      }
    }
  };
};
export default createWidgetSummaryRequest;
